import React from "react";
import { Checkbox } from "antd";

const CustomCheckboxGroup = ({ style, options, selectedValues, onChange }) => {
    return (
      <Checkbox.Group 
        options={options} 
        value={selectedValues} 
        onChange={onChange}
         className="custom-checkbox-group"
        style={{ ...style, display: "flex", flexDirection: "column", gap: "8px", }}
      />
    );
  };

export default CustomCheckboxGroup;
